import {
  useGetCohortSummaryByCohortProfileIdQuery,
  useLazyGetCohortSummaryByCohortProfileIdQuery,
  useGetCustomClinicalCharacteristicsMutation,
  datasetApiSlice,
  type CustomClinicalCharacteristicsRequest,
  type CustomClinicalCharacteristicsResponse,
} from './lib/cohortSummarySlice';

const upsertCohortSummaryQueryData = datasetApiSlice.util.upsertQueryData;

export {
  datasetApiSlice as cohortSummaryApiSlice,
  useGetCohortSummaryByCohortProfileIdQuery,
  useLazyGetCohortSummaryByCohortProfileIdQuery,
  useGetCustomClinicalCharacteristicsMutation,
  upsertCohortSummaryQueryData,
  type CustomClinicalCharacteristicsRequest,
  type CustomClinicalCharacteristicsResponse,
};

export {
  type EventRequest,
  type EventSummaryResults,
  type EventFilters,
  type ComputeEventsResponse,
} from './lib/eventsDrillDownApiSlice';
export {
  useGetEventSummaryMutation,
  useGetEventsMutation,
  useGetColumnStatsMutation,
  useGetEventTablesQuery,
  usePostComputeEventsMutation,
} from './lib/eventsDrillDownApiSlice';
